import {Injectable} from '@angular/core';
import {BaseHttpService} from '@core/ecv-http-services/base.service';
import {SessionService} from '@core/ecv-http-services/session.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DictAlias} from '../../../dict-panel/dict-alias.model';
import {CreateDictAlias} from '../../../dict-panel/create-dict-alias.model';

@Injectable()
export class DictAliasService extends BaseHttpService {

  private static getAliasesPath = 'api/ecv/dicts_aliases/';
  private static createAliasPath = DictAliasService.getAliasesPath + 'create';
  private static deleteAliasPath = DictAliasService.getAliasesPath + 'delete/';

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  getAliases(dictId: number): Observable<any> {
    return this.httpGet(DictAliasService.getAliasesPath + dictId);
  }

  createAlias(model: CreateDictAlias): Observable<any> {
    return this.httpPost(DictAliasService.createAliasPath, model);
  }

  deleteAlias(model: DictAlias): Observable<any> {
    return this.httpDelete(DictAliasService.deleteAliasPath + model.id + '/' + model.version);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/dict-alias.service.ts